import React from 'react';
import { flow, get } from 'lodash';
import { actions } from './reducer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col, Row, Well, FormGroup } from 'react-bootstrap';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import Box from '../../../../common/components/Box/Box';
import Button from '../../../../common/components/Button/Button';
import Loader from '../../../../common/components/Loader/Loader';
import { FormGroupRow, HorizontalFormControl } from '../../../../common/components';
import CheckboxGroup from '../../../../common/components/ReduxFormField/CheckboxGroup';
import { InternalButtonBar } from '../../../layout/components';
import AsyncMultiSelectMenu from '../../../../common/components/SelectMenu/AsyncMultiSelectMenu';

class SalesBannerForm extends React.Component {
  componentWillMount() {
    const { actions, salesBanner, dispatch, change } = this.props;

    if (!salesBanner.content) {
      actions.getSalesBannerContent();
    }

    if (salesBanner.content) {
      dispatch(
        change('data.attributes.sections', salesBanner.content.attributes.sections),
      );
      dispatch(
        change('data.attributes.metadata', salesBanner.content.attributes.metadata),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, change, salesBanner } = this.props;

    if (!salesBanner.content && nextProps.salesBanner.content) {
      dispatch(
        change(
          'data.attributes.sections',
          nextProps.salesBanner.content.attributes.sections,
        ),
      );
      dispatch(
        change(
          'data.attributes.metadata',
          nextProps.salesBanner.content.attributes.metadata,
        ),
      );
    }
  }

  handleSubmit = (formValues) => {
    const { actions, salesBanner } = this.props;
    actions.updateSalesBanner(formValues, salesBanner.content.id);
  };

  render() {
    const { handleSubmit, submitting, salesBanner, formValues } = this.props;

    if (salesBanner.loading) {
      return <Loader />;
    }

    return (
      <Form onSubmit={handleSubmit(this.handleSubmit)}>
        <Box>
          <Row>
            <Col sm={12}>
              <Well>
                <p>Useful variables:</p>
                <div>
                  <strong>Channel phone: </strong>
                  {'{{channel phone}}'}
                </div>
                <div>
                  <strong>Channel name: </strong>
                  {'{{channel name}}'}
                </div>
              </Well>
              <h2>Sales Banner</h2>

              <div className="">
                <Field
                  name="data.attributes.sections.header_content"
                  label="Header content:"
                  labelSize={2}
                  component={HorizontalFormControl}
                />
              </div>
              <div className="">
                <Field
                  name="data.attributes.sections.sub_header_content"
                  label="Sub-header content:"
                  labelSize={2}
                  component={HorizontalFormControl}
                />
              </div>
              <div className="">
                <Field
                  name="data.attributes.sections.small_print"
                  label="Small print:"
                  labelSize={2}
                  component={HorizontalFormControl}
                />
              </div>
              <FormGroup className="">
                <Field
                  name={'data.attributes.metadata.enabled'}
                  label={'Enable:'}
                  labelSize={2}
                  fieldSize={4}
                  component={CheckboxGroup}
                  options={[{ label: '', value: true }]}
                />
              </FormGroup>
              <FormGroupRow label="Tracking links:" labelSize={2}>
                <Field
                  name="data.attributes.sections.tracking_links"
                  filters={[{ type: 'broker_type', match: 'tracking' }]}
                  preSelectedOptions={get(
                    formValues,
                    'data.attributes.sections.tracking_links',
                    [],
                  )}
                  url={'/brokers?'}
                  component={AsyncMultiSelectMenu}
                />
              </FormGroupRow>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    button: (
                      <Button
                        type="submit"
                        bsStyle="primary"
                        className="pull-right"
                        disabled={submitting}
                      >
                        {salesBanner.saving && <i className="fa fa-cog fa-spin" />} Save
                      </Button>
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Box>
      </Form>
    );
  }
}

const FORM_NAME = 'SalesBannerForm';
export default flow([
  reduxForm({
    form: FORM_NAME,
  }),
  connect(
    (state) => ({
      salesBanner: state.salesBanner,
      formValues: getFormValues(FORM_NAME)(state),
    }),
    (dispatch) => ({
      dispatch,
      actions: bindActionCreators(actions, dispatch),
    }),
  ),
])(SalesBannerForm);
